import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=b8c1424e"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports